import React from 'react'
import { styled } from 'styled-components'
import { Link } from 'react-router-dom'
import {AiOutlineArrowRight} from 'react-icons/ai'

const ConnectAnnouncement = () => {
  return (
    <Container className='connect-announcement-container'>
        <h2>Connect with us.</h2>
        <div className="connect-announcement">
            <p>Join us in our journey towards academic excellence, research breakthroughs, community impact, and the empowerment of women and girls in engineering.</p>
            <button className='blip-btn'><Link to='/signup'>Get Started <AiOutlineArrowRight /></Link></button> 
        </div>
    </Container>
  )
}

const Container = styled.section`
    text-align: center;
    padding: 0 2em;
    margin: 10em 0;
    h2{
        font-size: 3rem;
    }
    p{
        font-size: 1.1rem;
    }
    .blip-btn{
        margin-top: 2em;
        a{
            color: var(--color-black);
            &:hover{
                svg{
                    transform: translateX(0.5em);
                }
                color:var(--primary-color)
            }
        }
    }

    /* Media Queries */
    @media only screen and (min-width: 800px){
        text-align: unset;
        display: flex;
        align-items: center;
        margin: 5em 0;
        gap: 2em;
        h2{
            width: 70%;
            text-align: center;
        }
        p{
            font-size:1.5rem;
        }
    }
`;


export default ConnectAnnouncement